
<div class="landing-container">
  <!-- View All Button -->
  <div class="container center-screen view-all-wrapper">
    <button class="btn btn-block btn-primary growbtn" mdbRipple type="button"
      *ngIf="!showFetch && enableClientList" (click)="viewAllLoans()">
      View all loan applications
    </button>
  </div>
  <div class="row justify-content-center my-1">
    <!-- Main Content Area -->
    <div *ngIf="showFetch">
      <!-- New Layout with Feature Flag and User Preference -->
      <div *ngIf="useNewLandingLayout; else oldLayout" class="landing-page">
        <!-- Filter Bar - Outside tabs, applies to active tab -->
        <div class="filter-bar">
          <div class="search-input">
            <input type="text"
                  class="form-control"
                  placeholder="Search by name, ID, or phone..."
                  [formControl]="searchControl"
                  aria-label="Search clients">
          </div>
          <div class="filter-dropdown">
            <select mdbDropdown class="form-select"
                    [formControl]="statusFilterControl"
                    aria-label="Filter by status">
              <option *ngFor="let option of statusOptions" [value]="option.value">
                {{ option.label }}
              </option>
            </select>
          </div>
          <div class="filter-dropdown">
            <select mdbDropdown class="form-select"
                    [formControl]="sortControl"
                    aria-label="Sort by">
              <option *ngFor="let option of sortOptions" [value]="option.value">
                {{ option.label }}
              </option>
            </select>
          </div>
          <button *ngIf="hasActiveFilters"
                  class="btn btn-sm btn-outline-secondary"
                  (click)="clearFilters()"
                  aria-label="Clear filters">
            <mdb-icon>clear</mdb-icon>
          </button>
          <div class="view-toggle-group">
            <button class="btn btn-sm"
                    [class.btn-primary]="viewMode === 'cards'"
                    [class.btn-outline-secondary]="viewMode !== 'cards'"
                    (click)="toggleViewMode('cards')"
                    aria-label="Card view">
              <mdb-icon>view_module</mdb-icon>
            </button>
            <button class="btn btn-sm"
                    [class.btn-primary]="viewMode === 'table'"
                    [class.btn-outline-secondary]="viewMode !== 'table'"
                    (click)="toggleViewMode('table')"
                    aria-label="Table view">
              <mdb-icon>view_list</mdb-icon>
            </button>
          </div>
        </div>

      <!-- Summary Metrics Cards - Clickable to load respective quotes -->
      <div class="metrics-grid">
        <!-- <mdb-card class="metric-card">
            <mdb-card-title class="bg-gradient gradient-header-active">
              <h4 class="text-white mb-0">Active Clients</h4>
            </mdb-card-title>
          <mdb-card-body>
            <mdb-card-title class="bg-gradient gradient-header-active">
              <h4 class="text-white mb-0">Active Clients</h4>
            </mdb-card-title>


              <mdb-card-text>
                Detailed information about active clients goes here.
              </mdb-card-text>
          </mdb-card-body>
        </mdb-card> -->
        <div class="metric-card new"
            [class.selected]="selectedCategory === 'new'"
            (click)="selectCategory('new')"
            role="button"
            tabindex="0"
            (keydown.enter)="selectCategory('new')"
            aria-label="View New & Pending Clients">
          <div class="gradient-header-new">
            <h3 class="text-white mb-0">New & Pending</h3>
          </div>
          <div class="metric-body">
            <div class="metric-row">
              <div class="metric-main">
                <div class="metric-value">{{ newClientsMetrics.total | number }}</div>
                <div class="metric-label">Applications</div>
              </div>
            </div>
            <div class="metric-stats">
              <div class="stat-item">
                <div class="stat-label">New</div>
                <div class="stat-value stat-new">{{ newClientsMetrics.newCount | number }}</div>
              </div>
              <div class="stat-item">
                <div class="stat-label">Pending</div>
                <div class="stat-value stat-pending">{{ newClientsMetrics.pendingCount | number }}</div>
              </div>
            </div>
            <div class="metric-stats">
              <div class="stat-item">
                <div class="stat-label">Avg Amount</div>
                <div class="stat-value">{{ newClientsMetrics.avgLoanAmount | zaRcurrency }}</div>
              </div>
              <div class="stat-item">
                <div class="stat-label">Submission Rate</div>
                <div class="stat-value">{{ newClientsMetrics.submissionRate | number:'1.0-0' }}%</div>
              </div>
            </div>
          </div>
        </div>

        <div class="metric-card active"
            [class.selected]="selectedCategory === 'active'"
            (click)="selectCategory('active')"
            role="button"
            tabindex="0"
            (keydown.enter)="selectCategory('active')"
            aria-label="View Active Clients">
          <div class="gradient-header-active">
            <h3 class="text-white mb-0">Active Clients</h3>
          </div>
          <div class="metric-body">
            <div class="metric-row">
              <div class="metric-main">
                <div class="metric-value">{{ activeClientsMetrics.total | number }}</div>
                <div class="metric-label">Total Applications</div>
              </div>
              <div class="metric-icon" *ngIf="activeClientsMetrics.urgentCount > 0">
                <mdb-icon class="text-warning">warning</mdb-icon>
                <span class="urgent-badge">{{ activeClientsMetrics.urgentCount }}</span>
              </div>
            </div>
            <div class="metric-stats">
              <div class="stat-item">
                <div class="stat-label">Total Value</div>
                <div class="stat-value">{{ activeClientsMetrics.totalValue | zaRcurrency }}</div>
              </div>
              <div class="stat-item">
                <div class="stat-label">Avg Amount</div>
                <div class="stat-value">{{ activeClientsMetrics.avgLoanAmount | zaRcurrency }}</div>
              </div>
            </div>
            <div class="metric-stats">
              <div class="stat-item">
                <div class="stat-label">Avg Days Active</div>
                <div class="stat-value">{{ activeClientsMetrics.avgDaysActive | number:'1.0-0' }}</div>
              </div>
              <div class="stat-item">
                <div class="stat-label">Completion Rate</div>
                <div class="stat-value">{{ activeClientsMetrics.completionRate | number:'1.0-0' }}%</div>
              </div>
            </div>
          </div>
        </div>

        <div class="metric-card compliance"
            *ngIf="withCompliance && ComplianceListCount > 0"
            [class.selected]="selectedCategory === 'compliance'"
            (click)="selectCategory('compliance')"
            role="button"
            tabindex="0"
            (keydown.enter)="selectCategory('compliance')"
            aria-label="View Compliance Clients">
          <div class="gradient-header-compliance">
            <h3 class="text-white mb-0">Compliance</h3>
          </div>
          <div class="metric-body">
            <div class="metric-row">
              <div class="metric-main">
                <div class="metric-value">{{ complianceMetrics.total | number }}</div>
                <div class="metric-label">Clients</div>
              </div>
              <div class="metric-icon" *ngIf="complianceMetrics.requiresAttention > 0">
                <mdb-icon class="text-danger">priority_high</mdb-icon>
              </div>
            </div>
            <div class="metric-stats" *ngIf="complianceMetrics.total > 0">
              <div class="stat-item">
                <div class="stat-label">Requires Action</div>
                <div class="stat-value text-danger">{{ complianceMetrics.requiresAttention | number }}</div>
              </div>
              <div class="stat-item">
                <div class="stat-label">Resolved</div>
                <div class="stat-value text-success">{{ complianceMetrics.resolved | number }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Quotes Section - Shows based on selected category -->
      <div *ngIf="selectedCategory" class="quotes-section">

        <!-- Loading State -->
        <div *ngIf="isLoading$ | async" class="quotes-grid">
          <div class="skeleton-card" *ngFor="let i of [1,2,3,4,5,6]">
            <div class="skeleton-line skeleton-title"></div>
            <div class="skeleton-line"></div>
            <div class="skeleton-line skeleton-text"></div>
            <div class="skeleton-line skeleton-amount"></div>
          </div>
        </div>

        <!-- Card View -->
        <div *ngIf="!(isLoading$ | async) && selectedCategory !== 'compliance' && viewMode === 'cards'" class="quotes-grid">
          <!-- Empty State -->
          <div *ngIf="(filteredQuotes$ | async)?.length === 0" class="empty-state">
            <div class="empty-icon">📋</div>
            <h3 class="empty-title">{{ hasActiveFilters ? 'No Matching Clients' : getEmptyStateTitle() }}</h3>
            <p class="empty-message">{{ hasActiveFilters ? 'Try adjusting your filters.' : getEmptyStateMessage() }}</p>
            <button *ngIf="hasActiveFilters" class="btn btn-primary btn-sm" (click)="clearFilters()">
              Clear Filters
            </button>
          </div>

          <!-- Quote Cards -->
          <div *ngFor="let quote of (filteredQuotes$ | async); trackBy: trackByQuoteId"
                class="quote-card ripple-surface-light shadow-3-soft {{getStatusClass(quote.status)}}"
                (click)="selectQuote(quote)"
                role="button"
                tabindex="0"
                (keydown.enter)="selectQuote(quote)"
                [attr.aria-label]="'Quote ' + quote.quoteId + ', Status: ' + quote.status">

            <div class="card-header">
              <div class="d-flex justify-content-between align-items-start">
                <div>
                  <span class="info-label">Application #</span>
                  <h4 class="application-number">{{ quote.quoteId }}</h4>
                  <!-- <h5 class="client-name mb-1">{{ quote.firstName }} {{ quote.lastName }}</h5>
                  <div class="client-id">ID: {{ quote.idNumber }}</div> -->
                </div>
                <span class="status-badge {{getBadgeClass(quote.status)}}">
                  {{ quote.status }}
                </span>
              </div>
            </div>

            <div class="card-body">
              <div class="quote-info">
                <div class="info-row">

                  <span class="client-name mb-1">{{ quote.firstName }} {{ quote.lastName }}</span>
                  <span class="client-id">{{ quote.idNumber }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Loan Amount:</span>
                  <span class="info-value loan-amount">{{ quote.capital | zaRcurrency }}</span>
                </div>
                <div class="info-row" *ngIf="quote.cellNumber">
                  <span class="info-label">Phone:</span>
                  <a href="tel:{{quote.cellNumber}}" class="info-value text-primary" (click)="$event.stopPropagation()">
                    {{ quote.cellNumber }}
                  </a>
                </div>
              </div>

              <div class="meta-info mt-2">
                <div *ngIf="quote.userName"><small>Consultant: {{ quote.userName }}</small></div>
                <div *ngIf="quote.employerName"><small>Employer: {{ quote.employerName }}</small></div>
              </div>
            </div>

            <!--<div class="quote-card-actions">
              <button class="btn btn-primary btn-sm btn-primary-action" mdbRipple (click)="$event.stopPropagation(); selectQuote(quote)">
                Continue
              </button>
              <button *ngIf="quote.cellNumber"
                      class="btn-icon"
                      [attr.aria-label]="'Call ' + quote.firstName"
                      (click)="$event.stopPropagation()">
                <i class="fas fa-phone"></i>
              </button>
            </div>-->
          </div>
        </div>
      </div>

      <!-- Table View -->
      <div *ngIf="!(isLoading$ | async) && selectedCategory !== 'compliance' && viewMode === 'table'" class="table-view-container">
        <div *ngIf="(filteredQuotes$ | async)?.length === 0" class="empty-state">
          <div class="empty-icon">📋</div>
          <h3 class="empty-title">{{ hasActiveFilters ? 'No Matching Clients' : getEmptyStateTitle() }}</h3>
          <p class="empty-message">{{ hasActiveFilters ? 'Try adjusting your filters.' : getEmptyStateMessage() }}</p>
          <button *ngIf="hasActiveFilters" class="btn btn-primary btn-sm" (click)="clearFilters()">
            Clear Filters
          </button>
        </div>
        <lms-gridview *ngIf="((filteredQuotes$ | async) || []).length > 0 && selectedCategory === 'active'"
                      id="tblActiveView"
                      class="w-100"
                      [table_config]="tableActive_config"
                      (onRowSelect)="viewClient($event)">
        </lms-gridview>
        <lms-gridview *ngIf="((filteredQuotes$ | async) || []).length > 0 && selectedCategory === 'new'"
                      id="tblNewView"
                      class="w-100"
                      [table_config]="tableNew_config"
                      (onRowSelect)="viewNewClient($event)">
        </lms-gridview>
      </div>

      <!-- Compliance Grid View -->
      <div *ngIf="selectedCategory === 'compliance' && withCompliance" class="compliance-grid-section mt-3">
        <div *ngIf="landingService.clientListLoading$ | async; else complianceTable" class="fade show" style="text-align: center; padding: 2rem">
          <i class="spinner-grow spinner-grow-sm"></i>
          <span class="m-1">Loading compliance clients...</span>
        </div>
        <ng-template #complianceTable>
          <lms-gridview id="tblCompliance"
                        class="w-100"
                        [table_config]="tableCompliance_config"
                        (onLoaded)="ComplianceListCount"
                        (onRowSelect)="ComplianceUpdate($event)">
          </lms-gridview>
        </ng-template>
      </div>
      </div>

      <!-- Old Layout Template (Feature Flag Fallback) -->
      <ng-template #oldLayout>
        <!-- Active Clients Accordion -->
        <mdb-accordion class="accordion-active mb-1">
          <mdb-accordion-item [collapsed]="PanelOpenState !== 1" (show)="setpanelOpenState(1)">
            <ng-template mdbAccordionItemHeader>
              <div class="basic-panel-header panel-heading">
                <span>Active clients: <strong>{{ActiveClientListCount || 0 | number}}</strong></span>
              </div>
            </ng-template>
            <ng-template mdbAccordionItemBody>
              <div class="agent-landing-container">
                <div *ngIf="landingService.clientListLoading$ | async; else loaded" class="fade show" style="text-align: center; height: 20px">
                  <i class="spinner-grow spinner-grow-sm"></i>
                  <span class="my-2">loading active and submitted..</span>
                  <br />
                </div>
                <ng-template #loaded>
                  <lms-gridview id="tblactive" class="w-100" [table_config]="tableActive_config" (onLoaded)="ActiveClientListCount"
                              appScrollIntoView="true" (onRowSelect)="viewClient($event)"></lms-gridview>
                </ng-template>
              </div>
            </ng-template>
          </mdb-accordion-item>

        <!-- New and Pending Clients Accordion -->
          <mdb-accordion-item [collapsed]="PanelOpenState !== 2" (show)="setpanelOpenState(2)">
            <ng-template mdbAccordionItemHeader>
              <div class="basic-panel-header">
                <span>New and pending clients: <b>{{NewClientListCount || 0 | number}}</b></span>
              </div>
            </ng-template>
            <ng-template mdbAccordionItemBody>
              <div class="agent-landing-container">
                <div *ngIf="landingService.newListLoading$ | async; else newloaded" class="fade show" style="text-align: center; height: 20px">
                  <i class="spinner-grow spinner-grow-sm"></i>
                  <span class="m-1">loading new and pending..</span>
                  <br />
                </div>
                <ng-template #newloaded>
                  <lms-gridview id="tblnew" class="w-100" [table_config]="tableNew_config" (onLoaded)="NewClientListCount"
                              (onRowSelect)="viewNewClient($event)"></lms-gridview>
                </ng-template>
              </div>
            </ng-template>
          </mdb-accordion-item>

          <mdb-accordion-item *ngIf="withCompliance"  [collapsed]="PanelOpenState !== 3" (show)="setpanelOpenState(3)">
            <ng-template mdbAccordionItemHeader>
              <div class="basic-panel-header">
                <span>Compliance clients: <strong>{{ComplianceListCount | number}}</strong></span>
              </div>
            </ng-template>
            <ng-template mdbAccordionItemBody>
              <div class="agent-landing-container">
                <div *ngIf="landingService.clientListLoading$ | async; else compl" class="fade show" style="text-align: center; height: 20px">
                  <i class="spinner-grow spinner-grow-sm"></i>
                  <span class="m-1">loading compliance..</span>
                  <br />
                </div>
                <ng-template #compl>
                  <lms-gridview id="tblCompliance" class="w-100" [table_config]="tableCompliance_config" (onLoaded)="ComplianceListCount"
                              (onRowSelect)="ComplianceUpdate($event)"></lms-gridview>
                </ng-template>
              </div>
            </ng-template>
          </mdb-accordion-item>
        </mdb-accordion>
      </ng-template>
    </div>
  </div>
</div>
